import { Container } from '@purpur/library';
import styled, { createGlobalStyle, css } from 'styled-components';

import { NAVIGATION_MODAL_ZINDEX } from '@telialt/common-constants/src/modal';
import {
    getPurpurColor,
    getPurpurShadow,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';
import { NavigationItem } from '@telialt/models/src/Navigation';
import { NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

export const displayOption = (option?: NavigationItem['displayOption']) => {
    if (option === 'Desktop only') {
        return css`
            display: none;

            ${purpurMedia('lg')`
                display: flex;
            `}
        `;
    }

    if (option === 'Mobile only') {
        return css`
            display: flex;

            ${purpurMedia('lg')`
                display: none;
            `}
        `;
    }

    return css``;
};

export const NavigationContentContainer = styled(Container)`
    justify-content: space-between;
    display: flex;
    height: 100%;
`;

type NavigationHeaderProps = {
    $height: number;
    $heightMobile: number;
};

export const StyledNavigation = styled.header<NavigationHeaderProps>`
    z-index: ${NAVIGATION_MODAL_ZINDEX - 1};
    position: relative;
    background-color: ${getPurpurColor('functionalWhite')};

    ${({ $heightMobile, $height }) => css`
        height: ${$heightMobile}px;

        ${purpurMedia('lg')`
            height: ${$height}px;
        `}
    `};
`;

export const ContextBar = styled.div<{ $height: number }>`
    justify-content: space-between;
    background-color: ${getPurpurColor('backgroundSecondary')};
    height: ${({ $height }) => $height}px;

    ${displayOption('Desktop only')}
`;

export const MainBar = styled.div<{ $height: number }>`
    display: flex;
    flex-direction: column;
    height: ${({ $height }) => $height}px;
    background-color: ${getPurpurColor('functionalWhite')};
    box-shadow: ${getPurpurShadow('sm')};

    position: var(--navigation-position);
    top: var(--navigation-main-bar-offset);
    left: 0;
    width: 100%;
    z-index: 2;
    transition: var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
`;

export const TopBar = styled.div`
    position: var(--navigation-position);
    top: var(--navigation-top-bar-offset);
    left: 0;
    width: 100%;
    z-index: 1;
    transition: var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
`;

export const LogoMenuContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0 ${getPurpurSpacing('300')};
`;

export const LogoBurgerContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    gap: 0 ${getPurpurSpacing('200')};
`;

export const CustomContentContainer = styled.div`
    display: flex;
    align-items: center;
`;

/**
 * .react-app-nav-bar has custom style in SCSS to show white white area (skeleton) while react app is loading and not mounted.
 * After navigation is initialized we no longer need this skeleton
 */
export const GlobalNavBarSkeletonResetStyles = createGlobalStyle`
    .react-app-nav-bar:before {
        display: none;
    }
`;
